<template>
	<div class="game-fps-counter">
		<figure>
			<img :src="game.high_resolution_image_url" :alt="game.name">
		</figure>
		<div class="games-footer">
			<figcaption :title="game.name">{{ game.name }}</figcaption>
			<div class="fps-bar">
				<div
					class="fps-progress"
					:class="fpsBarClass"
					:style="`width: ${fpsPercentage}%;`"
				/>
			</div>

			<h4 v-if="showPendingFpsTooltip" class="game-fps-counter__pending-fps">
				FPS pending
			</h4>
			<div
				v-else
				class="fps-counter"
				:class="{ 'fps-warning': game[`fps_${resolution}`] < 60 }"
			>
				<span>{{ game[`fps_${resolution}`] }}</span>fps
			</div>

			<div v-if="showPendingFpsTooltip" class="tooltip-container">
				<tooltip class-binding="fps-tooltip-prebuilds">
					{{ fpsPendingMessage }}
				</tooltip>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import CONSTANTS from "@/config/constants";
import Tooltip from "@c/generals/tooltip";

export default {
	name: "GameFpsCounter",
	components: {
		Tooltip
	},
	props: {
		game: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			fpsPendingMessage: CONSTANTS.FPS_PENDING_MESSAGE
		};
	},
	computed: {
		...mapState({
			resolution: state => state.StarterPc.resolution
		}),
		fpsPercentage() {
			const MAX_FPS = 300;
			return (this.game[`fps_${this.resolution}`] * 100) / MAX_FPS;
		},
		showPendingFpsTooltip() {
			return this.game[`fps_${this.resolution}`] == 0;
		},
		fpsBarClass() {
			if (this.game[`fps_${this.resolution}`] == 0) {
				return "fps-pending";
			} else if (this.game[`fps_${this.resolution}`] < 60) {
				return "fps-warning";
			}

			return "";
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.game-fps-counter {
	display: flex;
	flex-direction: column;
	position: relative;

	@media (min-width: 992px) {
		max-width: 205px;
		margin-left: 30px;

		&:first-child {
			margin-left: 0;
		}
	}

	@media (max-width: 991px) {
		flex-direction: row;
		margin-bottom: 15px;
	}

	figure {
		display: flex;
		justify-content: center;
		align-items: center;

		img {
			width: 205px;
			height: 310px;

			@media (min-width: 992px) and (max-width: 1200px) {
				width: 170px;
				height: 260px;
			}

			@media (max-width: 991px) {
				width: 80px;
				height: 100px;
			}
		}
	}

	&__pending-fps {
		color: #FFFFFF;
		font-size: 14px;
		font-style: italic;
		font-weight: bold;
		letter-spacing: 0;
	}

	.tooltip-container {
		display: none;
		position: absolute;
		bottom: -15%;
		right: -100%;
		z-index: 10;
	}

	.games-footer {
		@media (max-width: 991px) {
			margin-left: 10px;
			width: 100%;
		}

		figcaption {
			color: $white;
			font-size: 16px;
			font-weight: bold;
			line-height: 19px;
			margin-top: 15px;
			margin-bottom: 15px;
			letter-spacing: 1px;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}

		.fps-bar {
			background-color: #1a1b1e;
			height: 9px;
			border-radius: 2px;
			overflow: hidden;

			.fps-progress {
				background-color: #26ff5c;
				height: 100%;
				transition: width 1s;
			}
		}

		.fps-counter {
			background-color: #26ff5c;
			font-size: 14px;
			font-weight: bold;
			padding: 5px 10px;
			color: #1d2023;
			width: fit-content;
			margin-top: 15px;
			transform: skewX(-10deg);
			border-radius: 2px;
			text-transform: uppercase;
			margin-left: auto;

			span {
				font-size: 16px;
			}
		}

		.fps-warning {
			background-color: #B8904F !important;
		}

		.fps-pending {
			background-color: #5F6061 !important;
			width: 50% !important;
		}
	}

	.games-footer:hover .tooltip-container {
		display: block;
	}
}
</style>
